import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import CreatePage from '../../../composents/CreatePage'

const title = 'Consumers'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new consumer',
  breadcrumbs: [
    {
      title: title,
      link: '/clients/consumers',
    },
  ],
}

export default function CreateConsumer() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [clients, setClients] = useState([]),
    [cards, setCards] = useState([]),
    [card, setCard] = useState([]),
    [client, setClient] = useState()

  async function onGet() {
    let cli = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cli.status === 200) {
      let a = []
      cli.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      setClients(a)
    }

    let ca = await resources.card
      .readNoUsed('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (ca.status === 200) {
      let covertaToLabelValue = []
      ca.data.docs.forEach((el) => {
        covertaToLabelValue.push({
          value: el.id,
          label: el.cardNumber,
          user: el?.client,
        })
      })
      setCards(covertaToLabelValue)
    }
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (client) object.client = client.value
    if (card) object.cards = card.map((e) => e.value)

    setLoader(true)
    setErrors({})
    let res = await resources.consumer
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/clients/consumers')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  function onGetElement(params) {
    setCard(params)
  }

  const filterCard = () => {
    let all_cities = []
    if (client) {
      all_cities = cards.filter((e) => e.user === client.value)
    }
    return all_cities
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Client <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => setClient(e)}
                    options={clients}
                    isSearchable
                    isClearable
                    className={errors['client'] ? ' is-invalid' : ''}
                  />
                  {errors['client'] && <div className="invalid-feedback">{errors['client']}</div>}
                </div>

                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Card number
                  </label>
                  <Select
                    options={filterCard()}
                    onChange={onGetElement}
                    isSearchable
                    isMulti
                    isClearable
                    className={errors['card'] ? ' is-invalid' : ''}
                  />
                  {errors['card'] && <div className="invalid-feedback">{errors['card']}</div>}
                </div>

                <Field name="surname" className="mb-3" error={errors['surname']} required>
                  consumer name
                </Field>

                <Field name="email" type="email" error={errors['email']} className="mb-3" required>
                  Email
                </Field>

                <Field name="contacts" error={errors['contacts']} className="mb-3" required>
                  Contact
                </Field>

                <Field
                  name="password"
                  type="password"
                  error={errors['description']}
                  className="mb-3"
                  required
                >
                  Password
                </Field>

                <Field
                  name="password_confirmation"
                  type="password"
                  error={errors['password_confirmation']}
                  className="mb-3"
                  required
                >
                  password confirmation
                </Field>

                <Field
                  name="description"
                  type="textarea"
                  error={errors['description']}
                  className="mb-3"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
